module.exports = __webpack_public_path__ + "static/media/4.16a26ff9.JPG";